import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmDatepickerModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class AppVersionFormmetaModel extends FormMetaModel {
    constructor() {
        super('Version Update', ROUTE_PATH.appVersion, ROUTE_PATH.appVersionForm, 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const app_type = new SmMetaInputModel(
            'app_type',
            'app_type',
            'input',
            true,
            'col-12 col-md-6 col-lg-6',
            2,
            4,
            'App Type',
            'text',
            '',
            true,
            true,
            true,
            false,
            10,
            1
        );
        const app_version = new SmMetaInputModel(
            'app_version',
            'app_version',
            'input',
            true,
            'col-12 col-md-6 col-lg-6',
            2,
            4,
            'App Version',
            'text',
            '',
            false,
            true,
            true,
            false,
            10,
            1

        );
        

        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };
        return {
            formInfo,
            buttons,
            app_type,
            app_version,
            
        }
    }


}